import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Image from 'next/image';
export default function Avatar(_ref) {
  var post = _ref.post;
  var cmsUrl = 'https://cms.kreezus.tech';
  var imageUrl = "".concat(cmsUrl, "/assets/").concat(post === null || post === void 0 ? void 0 : post.author.avatar);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center",
    children: [/*#__PURE__*/_jsx("div", {
      className: "relative w-12 h-12 mr-4",
      children: /*#__PURE__*/_jsx(Image, {
        src: imageUrl,
        layout: "fill",
        className: "rounded-full",
        alt: post === null || post === void 0 ? void 0 : post.author.name
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "text-xl font-bold",
      children: post === null || post === void 0 ? void 0 : post.author.name
    })]
  });
}